<template>
  <div class="success-page">
    <div class="success-box">
      <div v-if="!errorOccurred">
        <h1 class="title">✔ 登入成功！</h1>
        <p class="message">驗證完成，準備進入後台戰場...</p>
        <div class="countdown-timer">
          {{ countdown }}
        </div>
        <p v-if="countdown === 0" class="redirect-message">正在傳送...</p>
      </div>
      <div v-if="errorOccurred">
        <h1 class="title error-title">⚠️ 登入失敗</h1>
        <p class="message error-message">{{ errorMessage }}</p>
        <p class="message">將在 {{ errorCountdown }} 秒後返回登入頁面...</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getTokenBySessionId } from '@/api/auth.api';

export default {
  name: 'LoginSuccessView',
  data() {
    return {
      countdown: 3,
      errorCountdown: 3,
      redirectTimer: null,
      errorTimer: null,
      errorOccurred: false,
      errorMessage: '',
    };
  },
  async created() {
    const sessionId = new URLSearchParams(window.location.search).get('sessionId');
    if (!sessionId) {
      this.handleLoginError('無效的登入會話，Session ID 缺失。');
      return;
    }

    try {
      const { token } = await getTokenBySessionId(sessionId);
      localStorage.setItem('jwt', token);
      this.startCountdown();
    } catch (err) {
      console.error('獲取 Token 失敗:', err);
      this.handleLoginError(err.response?.data?.message || '登入憑證驗證失敗，請稍後再試。');
    }
  },
  methods: {
    startCountdown() {
      this.redirectTimer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        }
        if (this.countdown === 0) {
          clearInterval(this.redirectTimer);
          this.$router.push('/'); // 導向後台首頁
        }
      }, 1000);
    },
    handleLoginError(message) {
      this.errorOccurred = true;
      this.errorMessage = message;
      this.errorTimer = setInterval(() => {
        if (this.errorCountdown > 0) {
          this.errorCountdown--;
        }
        if (this.errorCountdown === 0) {
          clearInterval(this.errorTimer);
          this.$router.push('/login');
        }
      }, 1000);
    }
  },
  beforeUnmount() {
    clearInterval(this.redirectTimer);
    clearInterval(this.errorTimer);
  }
};
</script>

<style scoped>
/* @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;700&family=Roboto:wght@300;400;700&display=swap'); */

.success-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #121212;
  background-image:
      radial-gradient(ellipse at bottom, rgba(80, 20, 80, 0.3) 0%, transparent 60%), /* Purple glow */
      linear-gradient(to bottom, rgba(10, 10, 15, 0.9) 0%, rgba(20, 20, 30, 0.95) 70%, #0a0a0a 100%);
  padding: 20px;
  box-sizing: border-box;
  font-family: 'Roboto', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  /* font-family: 'Cinzel', serif; */
  overflow: hidden;
}

.success-box {
  background-color: rgba(25, 25, 35, 0.7); /* Dark, semi-transparent panel */
  padding: 50px 60px;
  border-radius: 10px;
  box-shadow: 0 0 35px rgba(0, 0, 0, 0.75), inset 0 0 12px rgba(120, 80, 180, 0.15); /* Purple inner glow */
  text-align: center;
  width: 100%;
  max-width: 600px; /* Slightly wider for messages */
  animation: fadeInRise 0.8s ease-out forwards;
  border: 1px solid rgba(160, 100, 220, 0.6); /* Purple border */
  position: relative;
}

@keyframes fadeInRise {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.title {
  font-size: 30px;
  font-weight: 700;
  color: #50fa7b; /* Success green, fits dark theme */
  margin-bottom: 20px;
  text-shadow: 0 0 10px rgba(80, 250, 123, 0.5); /* Green glow */
}

.title.error-title {
  color: #ff5555; /* Error red */
  text-shadow: 0 0 10px rgba(255, 85, 85, 0.5); /* Red glow */
}

.message {
  font-size: 18px;
  color: #b0b0c0;
  margin-bottom: 25px;
  line-height: 1.7;
}

.message.error-message {
  color: #ffb8b8; /* Lighter red for error message text */
  margin-bottom: 15px;
}

.countdown-timer {
  font-size: 72px; /* Large countdown number */
  font-weight: bold;
  color: #ff8c69; /* Fiery orange-red from previous theme for countdown */
  text-shadow: 0 0 15px rgba(255, 140, 105, 0.6);
  margin-bottom: 20px;
  animation: pulse 1s infinite alternate;
}

@keyframes pulse {
  from {
    transform: scale(1);
    opacity: 0.8;
  }
  to {
    transform: scale(1.1);
    opacity: 1;
  }
}

.redirect-message {
  font-size: 16px;
  color: #8be9fd; /* Cyan for redirecting message, fits theme */
  font-style: italic;
}

/* Responsive */
@media (max-width: 600px) {
  .success-box {
    padding: 40px 30px;
    max-width: 90%;
  }

  .title {
    font-size: 26px;
  }

  .message {
    font-size: 16px;
  }

  .countdown-timer {
    font-size: 60px;
  }
}
</style>